

















































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import {
  BillSearchResponse,
  BillOverviewResponse,
  BulkDownloadStatusResponse,
  BillDownloadFile
} from '@/models/billResponse';
import { EnabledTypes } from '@/enums/enabledTypes';
import { BillTypes } from '@/enums/billTypes';
import { BillStatusTypes, getBillStatusTypeName } from '@/enums/billStatusTypes';
import { getPaymentStatusTypeName, PaymentStatusTypes } from '@/enums/paymentStatusTypes';
import Axios from 'axios';
import moment from 'moment';
import { BillSearchRequest } from '@/models/billRequest';
import { getGradeYearName } from '@/enums/gradeYears';
import { getReadTypeName, ReadTypes } from '@/enums/readTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import { FunctionTypes } from '@/enums/functionTypes';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';
import { BackgroundStatusTypes } from '@/enums/backgroundStatusTypes';

@Component({})
export default class BillList extends AvaivaledVue {
  private EnabledTypes = EnabledTypes;
  private BillTypes = BillTypes;
  private BillStatusTypes = BillStatusTypes;
  private getBillStatusTypeName = getBillStatusTypeName;
  private PaymentStatusTypes = PaymentStatusTypes;
  private getGradeYearName = getGradeYearName;
  private getReadTypeName = getReadTypeName;
  private ReadTypes = ReadTypes;

  private isLoading: boolean = false;
  private billList: BillOverviewResponse[] = [];
  private countAll: number = 0;

  private showSearchCondition = true;

  private isPDFDownload = true;
  private bulkDownloadTaskId = '';
  private dialogDownloadProgressVisible = false;
  private downloadStatus: BulkDownloadStatusResponse | null = null;
  private getBulkDownloadStatusId: any = null;

  get condition() {
    return this.$store.state.bill.billDownloadCondition;
  }

  get collectionAgency(): CollectionAgencyTypes {
    if (!this.user || !this.user.collectionAgency) {
      return CollectionAgencyTypes.None;
    }
    return this.user.collectionAgency;
  }

  get isPaypal() {
    switch (this.collectionAgency) {
      case CollectionAgencyTypes.PayPalAndCramSchool:
      case CollectionAgencyTypes.PayPalAndOther:
        return true;
      default:
        return false;
    }
  }

  get downloadProgress() {
    if (!this.downloadStatus) {
      return 0;
    }

    return Math.floor(100 * this.downloadStatus.completedCount / this.downloadStatus.count);
  }

  get downloadProgressStatus() {
    switch (this.downloadStatus?.status) {
      case BackgroundStatusTypes.Succeeded:
        return 'success';
      case BackgroundStatusTypes.Failed:
        return 'exception';
      default:
        return 'text';
    }
  }

  get downloadProgressText() {
    if (!this.downloadStatus) {
      return '';
    }

    return `${this.downloadStatus.completedCount} / ${this.downloadStatus.count}`;
  }

  get downloadCancelEnabled() {
    switch (this.downloadStatus?.status) {
      case BackgroundStatusTypes.Succeeded:
        return false;
      default:
        return true;
    }
  }

  public async created() {
    const ok = await this.pageBackCheck(FunctionTypes.Bill);
    if (!ok) {
      return;
    }
  }

  public async mounted() {
    await this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private async loadData() {
    this.isLoading = true;

    try {
      const req: BillSearchRequest = {
        perPage: this.condition.perPage,
        page: this.condition.page,
        sort: this.condition.sort,
        enabled: this.isPDFDownload
          ? true
          : this.condition.enabledType === EnabledTypes.None
            ? null
            : this.condition.enabledType === EnabledTypes.Enabled,
        billType: this.condition.billType || null,
        billStatus: this.isPDFDownload
          ? BillStatusTypes.Billed
          : this.condition.billStatus,
        paymentStatus: this.condition.paymentStatus || null,
        readType: this.condition.readType || null,
        billDateFrom: this.condition.billDateFrom,
        billDateTo: this.condition.billDateTo,
        billLimitDateFrom: this.condition.billLimitDateFrom,
        billLimitDateTo: this.condition.billLimitDateTo,
        ordinarySchoolId: this.condition.ordinarySchoolId,
        gradeYear: this.condition.gradeYear,
        tagList: this.condition.tagList,
        keyWord: this.condition.keyWord,
      };
      const res = await Axios.post<BillSearchResponse>('/api/bills', req);
      this.billList = res.data.bills.map((bill) => {
        let paymentStatus: PaymentStatusTypes;
        switch (bill.paymentStatus) {
          case PaymentStatusTypes.Paid:
          case PaymentStatusTypes.AutoPaid:
            paymentStatus = PaymentStatusTypes.Paid;
            break;
          default:
            paymentStatus = PaymentStatusTypes.Unpaid;
            break;
        }
        return {
          ...bill,
          paymentStatus,
        };
      });
      this.countAll = res.data.countAll;
    } catch (error) {
      this.billList = [];
    }

    this.isLoading = false;
  }

  private getRowNumber(index: number) {
    return this.condition.perPage * (this.condition.page - 1) + index + 1;
  }

  private getBillStatusTypeFormat(row: BillOverviewResponse) {
    const name = getBillStatusTypeName(row.billStatus);
    switch (row.billStatus) {
      case BillStatusTypes.Billed:
        return name;
    }

    return this.checkChargableBill(row)
      ? `${name}(請求可)`
      : `${name}(請求不可)`;
  }

  private checkChargableBill(row: BillOverviewResponse) {
    if (row.disabled) {
      return false;
    }

    if (row.billStatus === BillStatusTypes.Billed) {
      return false;
    }

    if (!row.billLimitDate) {
        // 決済日・支払期限が未設定
      return false;
    }

    const billLimitDate = moment(row.billLimitDate).format('YYYYMMDD');
    const now = moment().format('YYYYMMDD');
    if (billLimitDate < now) {
        // 決済日・支払期限が請求日より古い
        return false;
    }

    return true;
  }

  private getBillStatusTagType(row: BillOverviewResponse): string {
    switch (row.billStatus) {
      case BillStatusTypes.Billed:
        return 'success';
      case BillStatusTypes.Unbilled:
      default:
        return this.checkChargableBill(row) ? '' : 'danger';
    }
  }

  private getPaymentStatusTagType(paymentStatus: PaymentStatusTypes): string {
    switch (paymentStatus) {
      case PaymentStatusTypes.Paid:
      case PaymentStatusTypes.AutoUnpaid:
        return 'success';
      default:
        return 'danger';
    }
  }

  private getPaymentStatusTagName(paymentStatus: PaymentStatusTypes): string {
  switch (paymentStatus) {
      case PaymentStatusTypes.Paid:
      case PaymentStatusTypes.AutoUnpaid:
        return '既納';
      default:
        return '未納';
    }
  }

  private getReadTypeTagType(readType: ReadTypes): string {
    switch (readType) {
      case ReadTypes.Read:
        return 'success';
      default:
        return 'danger';
    }
  }

  private onChangeDownloadType() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangePage() {
    this.loadData();
  }

  private onChangeSort( {prop, order}: any ) {
    if (!prop) {
      this.condition.sort = '';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private onPageSizeChange(val: number) {
    this.condition.perPage = val;
  }

  private getRequestBody() {
    const req: BillSearchRequest = {
      perPage: 999999999,
      page: 1,
      sort: '',
      enabled: this.isPDFDownload
        ? true
        : this.condition.enabledType === EnabledTypes.None
          ? null
          : this.condition.enabledType === EnabledTypes.Enabled,
      billType: this.condition.billType || null,
      billStatus: this.isPDFDownload
        ? BillStatusTypes.Billed
        : this.condition.billStatus,
      paymentStatus: this.condition.paymentStatus || null,
      readType: this.condition.readType || null,
      billDateFrom: this.condition.billDateFrom,
      billDateTo: this.condition.billDateTo,
      billLimitDateFrom: this.condition.billLimitDateFrom,
      billLimitDateTo: this.condition.billLimitDateTo,
      ordinarySchoolId: this.condition.ordinarySchoolId,
      gradeYear: this.condition.gradeYear,
      tagList: this.condition.tagList,
      keyWord: this.condition.keyWord,
    };
    return req;
  }

  private async onBulkDownload() {
    if (this.isPDFDownload) {
      await this.onBulkDownloadPDF();
    } else {
      await this.onBulkDownloadCSV();
    }
  }

  private async onBulkDownloadPDF() {
    try {
      const message = `請求済みの${this.countAll}件を出力します。よろしいですか？`;

      await this.$confirm(message, 'PDF一括出力確認', {
        confirmButtonText: '一括出力',
        cancelButtonText: 'キャンセル',
        type: 'info',
        dangerouslyUseHTMLString: true
      });
    } catch (error) {
      return;
    }

    try {
      const req = this.getRequestBody();
      const response = await Axios.post<BulkDownloadStatusResponse>(
        '/api/bills/bulk-download-pdf',
        req,
      );
      if (response.status !== 200) {
        this.$notify.error({
          title: 'PDF一括出力エラー',
          message: 'PDF一括出力が失敗しました。',
          position: 'bottom-right',
        });
        return;
      }

      this.bulkDownloadTaskId = response.data.taskId;

      if (!this.bulkDownloadTaskId) {
        localStorage.removeItem('BillBulkDownloadTaskId');

        await this.$confirm('出力可能な請求情報が見つかりません。', {
          confirmButtonText: 'OK',
          type: 'error',
          showCancelButton: false,
        });
        return;
      }

      localStorage.setItem('BillBulkDownloadTaskId', this.bulkDownloadTaskId);

      this.getBulkDownloadStatus();
      this.dialogDownloadProgressVisible = true;
    } catch (error) {
      this.$notify.error({
        title: 'PDF一括出力エラー',
        message:
          (error.response && error.response.data) || 'PDF一括出力が失敗しました。',
        position: 'bottom-right',
      });
    }
  }

  private async onBulkDownloadCSV() {
    try {
      const message = `${this.countAll}件を出力します。よろしいですか？`;

      await this.$confirm(message, 'CSV一括出力確認', {
        confirmButtonText: '一括出力',
        cancelButtonText: 'キャンセル',
        type: 'info',
        dangerouslyUseHTMLString: true
      });
    } catch (error) {
      return;
    }

    try {
      const req = this.getRequestBody();
      const response = await Axios.post<BulkDownloadStatusResponse>(
        '/api/bills/bulk-download-csv',
        req,
      );
      if (response.status !== 200) {
        this.$notify.error({
          title: 'CSV一括出力エラー',
          message: 'CSV一括出力が失敗しました。',
          position: 'bottom-right',
        });
        return;
      }

      this.bulkDownloadTaskId = response.data.taskId;

      if (!this.bulkDownloadTaskId) {
        localStorage.removeItem('BillBulkDownloadTaskId');

        await this.$confirm('出力可能な請求情報が見つかりません。', {
          confirmButtonText: 'OK',
          type: 'error',
          showCancelButton: false,
        });
        return;
      }

      localStorage.setItem('BillBulkDownloadTaskId', this.bulkDownloadTaskId);

      this.getBulkDownloadStatus();
      this.dialogDownloadProgressVisible = true;
    } catch (error) {
      this.$notify.error({
        title: 'CSV一括出力エラー',
        message:
          (error.response && error.response.data) || 'CSV一括出力が失敗しました。',
        position: 'bottom-right',
      });
    }
  }

  private async getBulkDownloadStatus() {
    if (!this.bulkDownloadTaskId) {
      return;
    }

    const response = await Axios.get<BulkDownloadStatusResponse>(
      `/api/bills/bulk-download-status/${this.bulkDownloadTaskId}`,
    );

    this.downloadStatus = response.data;

    switch (response.data.status) {
      case BackgroundStatusTypes.Succeeded:
        this.downloadFile(this.bulkDownloadTaskId, response.data.fileType);
        break;
      case BackgroundStatusTypes.Failed:
        localStorage.removeItem('BillBulkDownloadTaskId');
        this.dialogDownloadProgressVisible = false;

        await this.$confirm(`${response.data.fileType}一括出力が失敗しました。`, {
          confirmButtonText: 'OK',
          type: 'error',
          showCancelButton: false,
        });
        break;
      case BackgroundStatusTypes.Canceled:
        break;
      default:
        this.getBulkDownloadStatusId = setTimeout(() => {
          this.getBulkDownloadStatus();
        }, 5000);
        break;
    }
  }

  private async downloadFile(taskId: string, fileType: string) {
    if (!taskId) {
      return;
    }

    try {
      const response = await Axios.post<BillDownloadFile>(
        `/api/bills/download-bulk-file/${taskId}`,
        null,
      );

      if (response.status === 200) {
        const link = document.createElement('a');
        link.href = response.data.url;
        link.setAttribute('download', response.data.fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        this.$confirm(`${fileType}一括出力が失敗しました。`, {
          confirmButtonText: 'OK',
          type: 'error',
          showCancelButton: false,
        });
      }
    } catch (error) {
      this.$confirm(`${fileType}一括出力が失敗しました。`, {
        confirmButtonText: 'OK',
        type: 'error',
        showCancelButton: false,
      });
    }

    localStorage.removeItem('BillBulkDownloadTaskId');
    this.dialogDownloadProgressVisible = false;
  }

  private async onBulkDownloadCancel() {
    if (!this.bulkDownloadTaskId) {
      return;
    }

    clearTimeout(this.getBulkDownloadStatusId);

    const response = await Axios.post(
      `/api/bills/cancel-bulk-download/${this.bulkDownloadTaskId}`,
      null,
    );

    localStorage.removeItem('BillBulkDownloadTaskId');
    this.dialogDownloadProgressVisible = false;
  }
}
